import { actionTypes } from "../utils";

export const types = {
  ...actionTypes('GET_USER'),
  ...actionTypes('LOGOUT_USER'),
  ...actionTypes('UPDATE_FIRST_LOGIN'),
};